import http from "./http.js";
import { Service } from "./models/Services.js";
import { Product } from "./models/Products.js";
import moment from "moment";
import _ from "lodash";
moment.locale("uk");

async function getContacts() {
  try {
    const response = await http.get("client-dashboard/contacts");
    return {
      manager: {
        title: response.data.manager?.title || "",
        email: response.data.manager?.email || "",
      },
      analyst: {
        title: response.data.analyst?.title || "",
        email: response.data.analyst?.email || "",
      } ,
    };
  } catch (err) {
    throw err;
  }
}

async function getBalance() {
  try {
    const response = await http.get("client-dashboard/balance");
    return {
      balanceHours: response.data.balanceHours,
      balanceAmount: response.data.balanceAmount,
    };
  } catch (err) {
    throw err;
  }
}

async function getPackage() {
  try {
    const response = await http.get("client-dashboard/package-recommendations");
    return {
      package: {
        id: response.data.package ? response.data.package.id : "",
        title: response.data.package ? response.data.package.title : "",
      },
      hours: response.data.hours ? response.data.hours : "",
    };
  } catch (err) {
    throw err;
  }
}

async function getLastInvoice() {
  try {
    const response = await http.get("client-dashboard/last-invoice");
    return {
      id: response.data.id,
      date: response.data.date,
      number: response.data.number,
      amount: response.data.amount,
      paymentStatus: response.data.paymentStatus,
      paymentsAmount: response.data.paymentsAmount,
      payments: response.data.payments.map(p => {
        return {
          id: p.id,
          date: p.date,
          amount: p.amount,
        };
      }),
    };
  } catch (err) {
    throw err;
  }
}

async function getInvoices() {
  try {
    const response = await http.get("client-dashboard/invoices");
    return response.data.result.map(i => {
      return {
        id: i.id,
        date: i.date,
        number: i.number,
        amount: i.amount,
        payedAmount: i.payedAmount,
        lastPaymentDate: i.lastPaymentDate,
        paymentStatus: i.paymentStatus,
      };
    });
  } catch (err) {
    throw err;
  }
}

async function getServices() {
  try {
    const { data } = await http.get("client-dashboard/services");
    return data.map(service => {
      return new Service(service);
    });
  } catch (err) {
    throw err;
  }
}

async function getProducts() {
  try {
    const { data } = await http.get("client-dashboard/products");
    return data.map(product => {
      return new Product(product);
    });
  } catch (err) {
    throw err;
  }
}

async function getClientPackages(filter = "", page = 1, pageSize = 500) {
  try {
    const response = await http.get("client-dashboard/packages", {
      params: {
        page,
        pageSize,
        "filter.searchTerm": filter.search ? filter.search : "",
        "filter.saleOption": filter.saleOptions ? filter.saleOptions.toString() : "",
      },
    });
    return response.data.result;
  } catch (err) {
    throw err;
  }
}

async function worklogUpdateReport(filter) {
  try {
    const response = await http.get(
      "client-dashboard/worklogs", {
        params: {
          from: filter.dateFrom,
          to: filter.dateTo,
          projectId: filter.projectId,
        },
      }
    );
    return response.data.map(w => {
      return {
        key: w.issue.key,
        numberedKey: _.toString(_.takeRight(_.words(w.issue.key))),
        summary: w.issue.summary,
        issueAuthor: w.issue.author,
        status: w.issue.status,
        dueDate: w.issue.dueDate
          ? moment(w.issue.dueDate).format("DD.MM.YY")
          : "",
        description: w.issue.description,
        customerDescription: w.issue.customerDescription,
        employee: w.employee,
        timeSpentSeconds: w.timeSpentSeconds,
        payedSeconds: w.payedSeconds,
        payedHours: w.payedHours,
        comment: w.comment || "",
        date: moment(w.date).format("DD.MM.YY"),
      };
    });
  } catch (err) {
    throw err;
  }
}

async function getClientProjects() {
  try {
    const response = await http.get("client-dashboard/project-references");
    return response.data.result;
  } catch (err) {
    throw err;
  }
}

async function balanceUpdateReport(filterParams) {
  try {
    const { dateFrom, dateTo, projectId } = filterParams;
    const response = await http.get("client-dashboard/balance-report", {
      params: {
        projectId,
        from: dateFrom,
        to: dateTo,
      },
    });
    return response.data.map(i => {
      return {
        month: moment(i.month).format("MMMM YY"),
        startMonthBalance: i.startMonthBalance,
        payedHours: i.payedHours,
        spentHours: i.spentHours,
        bonusHours: i.bonusHours,
        endMonthBalance: i.endMonthBalance,
        servicesHours: i.servicesHours,
      };
    });
  } catch (err) {
    throw err;
  }
}


export {
  getContacts,
  getPackage,
  getBalance,
  getLastInvoice,
  getInvoices,
  getServices,
  getClientPackages,
  worklogUpdateReport,
  getClientProjects,
  balanceUpdateReport,
  getProducts,
};